/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Showcase_UnbanInputs */



/**
* | output |
* | --- |
* | "Allowed back on the public listing" |
*
* @param {Activity_Showcase_UnbanInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_showcase_unban = /** @type {((inputs?: Activity_Showcase_UnbanInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Showcase_UnbanInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервер снова допущен в публичный список")
	return /** @type {LocalizedString} */ ("Allowed back on the public listing")
});